
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
const Statement = ({ t }) => {
    const statement = t('our_vision:statement', {}, { returnObjects: true });
    return (<section className={'statement'}>
            <div className="container">
                <div className="statement_wrapper">
                    <h2 className={'statement_title'}>{statement.title}</h2>
                    <div className="statement_content">
                        <p className={'statement_content_text text_1'}>{statement.text_1}</p>
                        <p className={'statement_content_text text_2'}>{statement.text_2}</p>
                    </div>
                </div>
            </div>
        </section>);
};
export default Statement;

    async function __Next_Translate__getStaticProps__196111dc733__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//about/vision/Statement/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196111dc733__ as getStaticProps }
  